export default __webpack_public_path__ + "static/media/NBS.bcf86e31.svg";